import { useCallback } from 'react';
import TagManager from 'react-gtm-module';

const useGoogleTagManager = (gtmId) => {
  const initGoogleTagManager = useCallback(() => {
    if (!gtmId) return;
    TagManager.initialize({
      gtmId,
    });
  }, [gtmId]);

  const gtag = useCallback((event, payload) => {
    return TagManager.dataLayer({
      dataLayer: {
        event,
        ...payload,
      },
    });
  }, []);

  return {
    initGoogleTagManager,
    gtag,
  };
};

export default useGoogleTagManager;
